export const jobEmploymentTypesSk = {
  jobEmploymentTypes: {
    'full_time': 'Plný úväzok',
    'part_time': 'Čiastočný úväzok',
    'contract': 'Dohoda',
    'freelance': 'Práca na živnosť',
    'temporary': 'Brigáda',
    'internship': 'Stáž',
    'seasonal': 'Sezónna práca'
  }
};
